const config = {
  vic: {
    theme: "FORMS_LIVE",
    favicon: "favicon.ico",
    description: "Forms Live Onboarding",
    ui: "https://vic.formslive-staging.com.au",
    api: "https://vic-api.formslive-staging.com.au",
  },
  vicnew: {
    theme: "FORMS_LIVE",
    favicon: "favicon.ico",
    description: "Forms Live Onboarding",
    ui: "https://vic.formslive-staging.com.au",
    api: "https://vic-api.formslive-staging.com.au",
  },
  flsa: {
    theme: "FORMS_LIVE",
    favicon: "favicon.ico",
    description: "Forms Live Onboarding",
    ui: "https://sa.formslive-staging.com.au",
    api: "https://sa-api.formslive-staging.com.au",
  },
  nsw: {
    ui: "https://nsw.formslive-staging.com.au",
    api: "https://nsw-api.formslive-staging.com.au",
  },
  act: {
    ui: "https://act.formslive-staging.com.au",
    api: "https://act-api.formslive-staging.com.au",
  },
  sa: {
    ui: "https://sa.staging.reiformslive.com.au",
    api: "https://sa-api.staging.reiformslive.com.au",
  },
  wa: {
    ui: "https://wa.formslive-staging.com.au",
    api: "https://wa-api.formslive-staging.com.au",
  },
  nt: {
    ui: "https://nt.formslive-staging.com.au",
    api: "https://nt-api.formslive-staging.com.au",
  },
  tas: {
    ui: "https://tas.formslive-staging.com.au",
    api: "https://tas-api.formslive-staging.com.au",
  },
  qld: {
    theme: "FORMS_LIVE",
    favicon: "favicon.ico",
    description: "Forms Live Onboarding",
    ui: "https://qld.formslive-staging.com.au",
    api: "https://qld-api.formslive-staging.com.au",
  },
};

export default config;
